<script lang="ts">
    import Player from 'svelte-react-player';
    import Fullscreen from 'svelte-fullscreen';
    import Preview from './Preview.svelte';
    import Close from './Close.svelte';
    import FullscreenCta from './FullscreenCta.svelte';

    export let loading = true;
    export let url = '';
    export let ctaVisible = false;
    export let onBtnClick: () => void = () => null;
    export let btnText = 'Click me!';
    export let btnBgColor = '#0076FF';
    export let btnColor = '#F0F0F0';
    export let thumbnail = '';
    export let onProgress: (progress: { playedSeconds: number }) => void = () => null;

    let playing = false;
    let full = false;
    let ratio = '56.25%';

    const handleFullscreenChange = () => {
        full = !full;

        if (full) {
            setTimeout(() => {
                ratio = `${screen.height}px`;
                playing = true;
            }, 1000); // time it takes to enter fullscreen
        } else {
            playing = false;
        }
    };
</script>

<Fullscreen on:change={handleFullscreenChange} let:onRequest let:onExit>
    <div>
        <div style="display: {playing ? 'none' : 'block'}">
            <Preview onPlayClick={() => onRequest()} src={thumbnail} {loading} />
        </div>
        {#if playing}
            <div class="fixed left-0 top-0 z-10 h-full w-full bg-black">
                <div class="absolute left-0 top-0 z-[1] h-full w-full">
                    <Player
                        {url}
                        {playing}
                        controls={false}
                        fluid
                        {ratio}
                        callbacks={{ onProgress }}
                    />
                </div>
                <Close onClose={() => onExit()} />
                <FullscreenCta
                    {btnText}
                    {btnColor}
                    {btnBgColor}
                    {onBtnClick}
                    visible={ctaVisible}
                />
            </div>
        {/if}
    </div>
</Fullscreen>
